export default __webpack_public_path__ + "static/hero-contact-7ab2f40c4a11876713f24b40f14bd6e1.jpg";